export default class Quote {
  constructor(quoteData) {
    this.quoteData = quoteData;
  }

  unquotedParts() {
    const quoteItems = this.quoteData.quote_items;
    const unquotedParts = [];
    for (let key in quoteItems) {
      let itemData = quoteItems[key];
      itemData.parts_unquoted.forEach(part => unquotedParts.push(part));
    }
    return unquotedParts;
  }

  quotedParts() {
    const quoteItems = this.quoteData.quote_items;
    const quotedParts = [];
    for (let key in quoteItems) {
      let itemData = quoteItems[key];
      itemData.parts_included.forEach(part => quotedParts.push(part));
    }
    return quotedParts;
  }
}
